module.exports = __webpack_public_path__ + "img/perry-pocket.jpg_w545.0b3d8fcb.jpg";